import React from "react"
import { DrawerButton } from "src/mtska-frontend-app-component";
import { useTranslation } from 'react-i18next';

const ImportButton = ({ dataProviderName, icon, moduleName, callback, disabled }) => {
    const { t } = useTranslation();

    return (
        <DrawerButton
            drawerRoute={'imports/list'}
            className="button-import"
            params={{
                filters: {
                    items: [{
                        operator: "equals",
                        field: "model",
                        value: dataProviderName,
                    }]
                },
                currentDataProviderName: dataProviderName,
                moduleName: moduleName,
            }}
            callback={callback}
            label={t("Import")}
            disabled={disabled}
            icon={icon}
        />
    );
};


export default ImportButton;
